import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { PaymentListLayer } from '../components/userPoint/PaymentListLayer'

export const PaymentListPage = () => {
  return (
    <MasterLayout>
        <PaymentListLayer />
    </MasterLayout>
  )
}
